module.exports = __webpack_public_path__ + "static/media/hogar.84451e0a.svg";